import {
  isActionTypeDisplay,
  isElementTypeContainer,
} from '@/common/converter/utils/element'

/**
 * return api type 'band' or 'catalog'
 * @param elementList
 * @returns {string}
 */
export const getApiType = (elementList = {}) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action = element?.actionList?.find(isActionTypeDisplay) ?? {}

  return action?.execute?.data?.apiType ?? ''
}
